import {
  FormControl,
  TextField,
  CircularProgress,
  Typography,
  Box,
  LinearProgress,
  IconButton,
  Paper,
  Checkbox,
  Button,
  Card,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { useEffect, useState } from "react";
import axios from "axios";
import RequestGenerated from "./components/CompanyKYCrequestgenerated/CompanyKYCRequestGenerated";
import "./App.css";
import { Spin } from "antd";

function App() {
  const [cin, setCin] = useState("");
  const [pan, setPan] = useState("");
  const [gst, setGst] = useState("");
  const [status, setStatus] = useState("");
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [successPage, setSuccessPage] = useState(false);
  const [error, setError] = useState("");
  console.log(window.location.pathname.split("/"));

  const id = window.location.pathname.split("/")[2];
  const token = window.location.pathname.split("/")[3];
  useEffect(() => {
    return () => files?.forEach((file) => URL.revokeObjectURL(file.preview));
  }, [files]);

  useEffect(() => {
    axios
      // .get(`http://192.168.0.95:5050/v1/company/kyb?id=${id}`, {
        .get(`https://kycapi.escrowstack.io/v1/company/kyb?id=${id}`, {
        headers: {
          // aws_cognito_id_token: authTokens.idToken,
          aws_cognito_id_token: token,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        console.log("data-->", res.data);
        setStatus(res.data.status);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const validateFields = () => {
    if (!cin) return "CIN is required.";
    if (!/^[A-Za-z0-9]{21}$/.test(cin)) return "Invalid CIN format.";
    if (!pan) return "PAN is required.";
    if (!/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(pan)) return "Invalid PAN format.";
    if (!gst) return "GSTIN is required.";
    if (
      !/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$/.test(
        gst
      )
    )
      return "Invalid GSTIN format.";
    return null;
  };

  const handleSubmit = async () => {
    const formData = new FormData();
    formData.append("kyb_id", id);
    formData.append("cin", cin);
    formData.append("pan", pan);
    formData.append("gst", gst);
    files.forEach((file) => {
      formData.append("files", file.file);
    });

    const validationError = validateFields();
    if (validationError) {
      setError(validationError);
      return;
    }

    setLoading(true);
    setError("");
    try {
      const res1 = await axios.post(
        // `http://192.168.0.95:5051/v1/company/kyb/form`,
        `https://digiowebhooks.escrowstack.io/v1/company/kyb/form`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (res1.status === 200) {
        setLoading(false);
        setSuccessPage(true);
      }
    } catch (err) {
      setError("Error occurred while submitting the form");
    } /* finally {
      setLoading(false);
    } */
  };

  const handleClear = () => {
    setCin("");
    setPan("");
    setGst("");
    setError("");
  };

  const handleFileChange = (event) => {
    const validExtensions = [".pdf", ".jpeg", ".jpg"];
    const newFiles = Array.from(event.target.files).map((file) => ({
      file,
      name: file.name,
      size: (file.size / (1024 * 1024)).toFixed(2) + " MB",
      progress: 0,
      preview: URL.createObjectURL(file),
    }));

    const isValidFile = (file) => {
      const extension = file.name
        .toLowerCase()
        .slice(file.name.lastIndexOf("."));
      return validExtensions.includes(extension);
    };

    const filteredFiles = newFiles.filter(({ file }) => isValidFile(file));

    if (filteredFiles.length !== newFiles.length) {
      // setError("Only PDF or JPEG files are allowed.");
      // setSnackbarOpen(true);
      alert("Only PDF or JPEG files are allowed.");
      return;
    }
    const duplicateFiles = filteredFiles.filter(({ name }) =>
      files.some((existingFile) => existingFile.name === name)
    );

    if (duplicateFiles.length > 0) {
      alert("Duplicate files are not allowed.");
      return;
    }

    const totalSize =
      newFiles.reduce((acc, file) => acc + file.file.size, 0) / (1024 * 1024);
    if (files.length + newFiles.length > 10 || totalSize > 5) {
      // setError("Max 10 files and total file size 5MB");
      alert("Max 10 files and total file size 5MB");
      return;
    }

    setFiles((prevFiles) => [...prevFiles, ...newFiles]);
    simulateUpload(newFiles);
  };

  const simulateUpload = (newFiles) => {
    newFiles.forEach((file) => {
      const interval = setInterval(() => {
        setFiles((prevFiles) => {
          const updatedFiles = prevFiles.map((f) => {
            if (f.name === file.name) {
              const newProgress = Math.min(f.progress + 10, 100);
              if (newProgress === 100) {
                clearInterval(interval);
              }
              return { ...f, progress: newProgress };
            }
            return f;
          });
          return updatedFiles;
        });
      }, 200);
    });
  };

  const handleRemoveFile = (index) => {
    setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  function FormAlreadyFilledModal() {
    const [open, setOpen] = useState(true); // State to control modal visibility

    const handleClose = () => {
      setOpen(false);
    };

    return (
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-filled-dialog-title"
        sx={{ "& .MuiDialog-paper": { borderRadius: 2, padding: 2 } }}
      >
        <DialogTitle
          id="form-filled-dialog-title"
          sx={{ textAlign: "center", fontWeight: 600 }}
        >
          Form Submission Notice
        </DialogTitle>
        <DialogContent>
          <Typography
            variant="body1"
            sx={{ textAlign: "center", color: "#DC3545" }}
          >
            This form has already been submitted.
          </Typography>
        </DialogContent>
        {/* <DialogActions sx={{ justifyContent: "center", paddingBottom: 2 }}>
          <Button
            onClick={handleClose}
            variant="contained"
            sx={{
              backgroundColor: "#2348AB",
              color: "#ffffff",
              fontWeight: 600,
              "&:hover": { backgroundColor: "#1d3c8f" },
            }}
          >
            Close
          </Button>
        </DialogActions> */}
      </Dialog>
    );
  }

  console.log("files", files);

  return (
    <>
      {status === "REQUESTED" ? (
        <Spin
          size="large"
          tip="Loading..."
          spinning={loading}
          wrapperClassName="spin-center-wrapper"
        >
          <div className="container h-100 d-flex justify-content-center align-items-center">
            {!successPage ? (
              <div className="d-flex justify-content-center align-items-center pageHeight">
                <Card
                  sx={{
                    width: "600px",
                    boxShadow: 3,
                    padding: 4,
                    borderRadius: 2,
                    backgroundColor: "#fff",
                  }}
                >
                  <div className="d-flex justify-content-center align-items-center p-4">
                    <img alt="" src="/esc_logo.svg" />
                  </div>
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <Typography variant="h6" sx={{ fontWeight: 600 }}>
                      Enter Company KYC Details
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        color: "#2348AB",
                        cursor: "pointer",
                        fontWeight: 500,
                        textDecoration: "underline",
                      }}
                      onClick={handleClear}
                    >
                      Clear
                    </Typography>
                  </div>
                  {/* CIN Input */}
                  <Box mb={3}>
                    <TextField
                      fullWidth
                      label="CIN"
                      value={cin}
                      onChange={(e) => setCin(e.target.value)}
                      variant="outlined"
                      error={!!error && error.includes("CIN")}
                      helperText={error && error.includes("CIN") ? error : ""}
                    />
                  </Box>
                  {/* PAN Input */}
                  <Box mb={3}>
                    <TextField
                      fullWidth
                      label="PAN"
                      value={pan}
                      onChange={(e) => setPan(e.target.value)}
                      variant="outlined"
                      error={!!error && error.includes("PAN")}
                      helperText={error && error.includes("PAN") ? error : ""}
                    />
                  </Box>
                  {/* GSTIN Input */}
                  <Box mb={3}>
                    <TextField
                      fullWidth
                      label="GSTIN"
                      value={gst}
                      onChange={(e) => setGst(e.target.value)}
                      variant="outlined"
                      error={!!error && error.includes("GSTIN")}
                      helperText={error && error.includes("GSTIN") ? error : ""}
                    />
                  </Box>
                  {/* Upload Documents Section */}
                  <Typography
                    variant="subtitle1"
                    sx={{ textAlign: "center", fontWeight: 600, mb: 2 }}
                  >
                    Upload Documents
                  </Typography>
                  <Box
                    sx={{
                      width: "100%",
                      maxWidth: 400,
                      margin: "auto",
                      padding: 2,
                      border: "1px dashed #AAAAAA",
                      borderRadius: 2,
                    }}
                  >
                    {files?.map((file, index) => (
                      <Paper
                        key={index}
                        variant="outlined"
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          padding: 1,
                          marginBottom: 1,
                          borderRadius: 2,
                          border: "1px solid #e0e0e0",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            marginRight: 2,
                          }}
                        >
                          {file.preview ? (
                            file.file.type === "application/pdf" ? (
                              <embed
                                src="/pdf-logo.svg"
                                alt={file.name}
                                style={{
                                  width: 40,
                                  height: 40,
                                  borderRadius: 4,
                                }}
                              />
                            ) : (
                              <img
                                src={file.preview}
                                alt={file.name}
                                style={{
                                  width: 40,
                                  height: 40,
                                  objectFit: "cover",
                                  borderRadius: 4,
                                }}
                              />
                            )
                          ) : null}
                        </Box>
                        <Box
                          sx={{
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            marginRight: 1,
                          }}
                        >
                          <Typography variant="body2" sx={{ fontWeight: 500 }}>
                            {file.name}
                          </Typography>
                          <Typography
                            variant="caption"
                            color="textSecondary"
                            className="w-100"
                          >
                            {file.size}
                          </Typography>
                        </Box>
                        <IconButton
                          onClick={() => handleRemoveFile(index)}
                          size="small"
                        >
                          <Close fontSize="small" />
                        </IconButton>
                      </Paper>
                    ))}
                    <Button
                      variant="contained"
                      component="label"
                      startIcon={
                        <img
                          src="/fileUpload.svg"
                          alt="Upload Icon"
                          style={{ width: 24, height: 24 }}
                        />
                      }
                      sx={{
                        marginTop: 2,
                        padding: 1.5,
                        border: "2px dotted #AAAAAA",
                        borderRadius: 2,
                        fontSize: "14px",
                        width: "100%",
                        backgroundColor: "#ffffff",
                        color: "#777777",
                        boxShadow: "none",
                        textTransform: "none",
                        "&:hover": {
                          backgroundColor: "#f5f5f5",
                        },
                      }}
                    >
                      Drag & drop the file here or{" "}
                      <span
                        style={{
                          textDecoration: "underline",
                          color: "#2348AB",
                          fontWeight: 700,
                        }}
                      >
                        Click to upload
                      </span>
                      <input
                        type="file"
                        hidden
                        multiple
                        accept="application/pdf,image/jpeg"
                        onChange={handleFileChange}
                      />
                    </Button>
                    <Typography
                      variant="caption"
                      display="block"
                      sx={{
                        marginTop: 1,
                        textAlign: "center",
                        color: "#757575",
                      }}
                    >
                      (File type PDF & JPEG / Max 10 / Max Total File Size 5MB)
                    </Typography>
                  </Box>
                  {/* Submit Button */}
                  <div
                    className="d-flex justify-content-center align-items-center p-4"
                    onClick={handleSubmit}
                  >
                    <Button
                      variant="contained"
                      sx={{
                        width: "75%",
                        backgroundColor: "#2348AB",
                        fontWeight: 600,
                      }}
                      disabled={loading}
                    >
                      Proceed
                    </Button>
                  </div>
                </Card>
              </div>
            ) : (
              <RequestGenerated />
            )}
          </div>
        </Spin>
      ) : (
        <FormAlreadyFilledModal />
      )}
    </>
  );
}

export default App;
